import Tooltip from '@mui/material/Tooltip';

export const truncateText = (text, maxLength) => (
    <Tooltip title={text}>
        <span>{text?.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "N/A"}</span>
    </Tooltip>
);

export const isImage = (filePath) => {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
    return imageExtensions.some(ext => filePath?.toLowerCase()?.endsWith(ext));
};

// Helper function to get an icon based on file type
export const getFileIcon = (filePath) => {
    if (filePath?.endsWith('.pdf')) return '📄';
    if (filePath?.endsWith('.zip') || filePath?.endsWith('.rar')) return '🗜️';
    if (filePath?.endsWith('.doc') || filePath?.endsWith('.docx')) return '📝';
    return '📁'; // Default file icon
};

export const formatPhoneNumber = (rawNumber, formatPattern) => {
    // Check if rawNumber is defined before attempting to use replace
    if (rawNumber === undefined) {
        return ""; // or handle the undefined case appropriately
    }

    // Keep only digits from the raw number
    const digits = rawNumber.replace(/\D/g, "");
    let digitIndex = 0;

    // Replace only digit placeholders in the format pattern (ignore its digits)
    return formatPattern.replace(/\d/g, () => digits[digitIndex++] || "");
};

export const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
    return `${size} ${sizes[i]}`;
};

export const timestampToDate = (timestamp, withTime = false) => {
    if (!timestamp) return '';

    const date = new Date(parseInt(timestamp));

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');

    if (withTime) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    return `${year}-${month}-${day}`;
};